export const uiStore = {
  namespaced: true,
  state: () => ({
    offscreenVisible: false,
    pageHeaderVisible: false
  }),
  mutations: {
    toggleOffscreen (state) {
      state.offscreenVisible = !state.offscreenVisible
    },
    closeOffscreen (state) {
      state.offscreenVisible = false
    },
    showPageHeader (state) {
      state.pageHeaderVisible = true
    },
    hidePageHeader (state) {
      state.pageHeaderVisible = false
    }
  }
}
